
import React from 'react'

const AgreementsListComponentLoadable = React.lazy(() => import('./AgreementsTableComponent'));
const DetailAgreementComponentLoadable = React.lazy(() => import('./Product'));
const AgreementProductDetailsComponentLoadable = React.lazy(() => import('./Product/AgreementProductDetailsComponent'));
export {
    AgreementsListComponentLoadable,
    DetailAgreementComponentLoadable,
    AgreementProductDetailsComponentLoadable
}